/**
 * A practice user can hold several roles: a primary ``role`` plus any
 * ``additional_roles`` (e.g. a principal dentist who is ADMIN + Practitioner).
 * Dentist pickers must treat someone as a practitioner when Practitioner is
 * ANY of their roles — checking only the primary role silently drops dual-role
 * dentists the moment their primary role is switched to ADMIN.
 *
 * ``additional_roles`` is embedded by the practice-users LIST endpoint
 * (``/practices/{id}/users/``); a payload without it falls back to the primary
 * role alone.
 */
export const getAllRoles = (practiceUser) => [
    practiceUser?.role,
    ...(Array.isArray(practiceUser?.additional_roles) ? practiceUser.additional_roles : []),
].filter((role) => typeof role === 'string' && role);

export const hasPractitionerRole = (practiceUser) =>
    getAllRoles(practiceUser).some((role) => role.toUpperCase() === 'PRACTITIONER');

// Practice ADMIN as the primary role OR an additional role — mirrors the
// backend template guard (IsPracticeAdminForFormDeliveryWrites).
export const hasAdminRole = (practiceUser) =>
    getAllRoles(practiceUser).some((role) => role.toUpperCase() === 'ADMIN');
